import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextIndent"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.5 4.5H21V6H10.5V4.5ZM10.5 9H21V10.5H10.5V9ZM5.25 13.5H21V15H5.25V13.5ZM5.25 18H21V19.5H5.25V18ZM3 10.1925L5.4675 7.5L3 4.8075L4.065 3.75L7.53 7.5L4.065 11.25L3 10.1925Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextIndent.vue"]]);
